import * as yup from 'yup';

const passwordRegExp =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/u;

// const phoneRegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/u;

export const emailValidationRule = yup
    .string()
    .required('Please enter your email')
    .email('Please enter a valid email address');

const nameValidationRule = (type: 'first' | 'last') =>
    yup
        .string()
        .required(`Please enter your ${type} name`)
        .min(3, 'Enter at least 3 characters');

export const firstNameValidationRule = nameValidationRule('first');

export const lastNameValidationRule = nameValidationRule('last');

export const passwordValidationRule = yup
    .string()
    .required("Password can't be blank")
    .min(8, 'Password must be at least 8 characters long')
    .matches(
        passwordRegExp,
        'Password must have at least one alphanumeric character, digit, uppercase and special character.'
    );

export const ageValidationRule = yup
    .number()
    .required("Age can't be blank")
    .typeError("Age can't be blank")
    .positive('Age must be greater than 0');

export const optionalNumberRule = yup
    .number()
    .notRequired()
    .positive('Number has to be greater than 0')
    .transform((value) => (isNaN(value) ? undefined : value));

export const optionalStringRule = yup
    .string()
    .notRequired()
    .transform((value) => value || undefined);

export const passwordMatchValidationRule = (ref: string) =>
    yup.string().oneOf([yup.ref(ref), null], 'Passwords must match');

export const phoneValidationRule = yup
    .string()
    .required("Phone number can't be blank");
// .matches(phoneRegExp, 'Please enter a valid phone number format.');
